
<svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8.5 17C3.80558 17 0 13.1944 0 8.5C0 3.80558 3.80558 0 8.5 0C13.1944 0 17 3.80558 17 8.5C17 10.4856 16.3192 12.3122 15.1782 13.7591L19.3672 17.9046C19.7597 18.2931 19.763 18.9263 19.3745 19.3188C18.9861 19.7114 18.3529 19.7147 17.9603 19.3262L13.7645 15.1739C12.3168 16.3174 10.4881 17 8.5 17ZM8.5 15C12.0899 15 15 12.0899 15 8.5C15 4.91015 12.0899 2 8.5 2C4.91015 2 2 4.91015 2 8.5C2 12.0899 4.91015 15 8.5 15Z"
    fill="#4B4C52"
  />
</svg>
